var BaseApi = /** @class */ (function () {
    function BaseApi(context) {
        this.context = context;
    }
    BaseApi.prototype.getWebStorage = function () {
        return this.context.getWebStorage();
    };
    BaseApi.prototype.getCurrentUser = function () {
        return this.context.getCurrentUser();
    };
    BaseApi.prototype.isUserLoggedIn = function () {
        return this.context.isUserLoggedIn();
    };
    BaseApi.prototype.getSiteToken = function () {
        return this.context.getSiteToken();
    };
    BaseApi.prototype.getAppDefinitionId = function () {
        return this.context.getAppDefinitionId();
    };
    BaseApi.prototype.experimentEnabled = function (key) {
        return this.context.experimentEnabled(key);
    };
    BaseApi.prototype.getHTTPClient = function () {
        return this.context.getHTTPClient();
    };
    return BaseApi;
}());
export { BaseApi };
//# sourceMappingURL=BaseApi.js.map